import { stringToNumber } from "@/helpers/utils";
import { ColorTag, Tags } from "./index";
import { Button, Tooltip } from "@altimateai/lego";
import { Stack } from "@altimateai/lego";

interface ColorInsightTagsProps {
  tags: string[];
  onClick?: (tag: string) => void;
  labelFn?: (item: string) => string;
  showMore?: boolean;
}

const colors = ["blue", "orange", "yellow", "purple", "dark_green"];

const ColorInsightTags = ({
  tags,
  onClick,
  labelFn = i => i,
  showMore = false,
}: ColorInsightTagsProps) => {
  const isClickable = typeof onClick === "function";

  if (!tags.length) return null;

  const visibleTags = showMore ? [tags[0]] : tags;
  const remainingTags = showMore ? tags.slice(1) : [];
  const remainingCount = remainingTags.length;

  const renderTag = (t: string, disableTruncation = false) => {
    const tag_rk = labelFn(t);
    return isClickable ? (
      <button
        key={tag_rk}
        type="button"
        className="al-border-none al-bg-transparent al-p-0 al-cursor-pointer"
        onClick={() => onClick(t)}
        aria-label={`Tag: ${tag_rk}`}
      >
        <ColorTag
          color={colors[stringToNumber(tag_rk, colors.length)]}
          label={tag_rk}
          disableTruncation={disableTruncation}
        />
      </button>
    ) : (
      <div key={tag_rk} aria-label={`Tag: ${tag_rk}`}>
        <ColorTag
          color={colors[stringToNumber(tag_rk, colors.length)]}
          label={tag_rk}
          disableTruncation={disableTruncation}
        />
      </div>
    );
  };

  return (
    <div className="al-inline-block" aria-label="insights list">
      <Tags>
        {visibleTags.map(tag => renderTag(tag, false))}
        {showMore && remainingCount > 0 && (
          <Tooltip
            title={
              <Stack direction="column" className="al-p-2">
                {remainingTags.map(tag => renderTag(tag, true))}
              </Stack>
            }
          >
            <Button variant="link" className="!al-px-0">{`+${remainingCount}`}</Button>
          </Tooltip>
        )}
      </Tags>
    </div>
  );
};

export default ColorInsightTags;
